import { render } from "./ViewNavButtons.vue?vue&type=template&id=72e45b25&scoped=true"
import script from "./ViewNavButtons.vue?vue&type=script&lang=js"
export * from "./ViewNavButtons.vue?vue&type=script&lang=js"

import "./ViewNavButtons.vue?vue&type=style&index=0&id=72e45b25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e45b25"]])

export default __exports__